<template>
	<div class="videolist">
		<div class="breadcrumb">菜单列表</div>
		<div class="searchBtn">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain>添加</el-button>
			<el-button size='small' type="warning" @click="edit" plain>编辑</el-button>
			<el-button size='small' type="danger" @click="del" plain>删除</el-button>
	    </div>
	    <el-table ref="multipleTable" :data="tableData3" highlight-current-row  tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
		    <el-table-column prop="id" label="ID"></el-table-column>
		    <el-table-column prop="menuName" label="菜单名称"></el-table-column>
		    <el-table-column prop="menuAddress" label="菜单URL"></el-table-column>
		    <el-table-column prop="menuLevel" label="菜单类型">
		    	<template slot-scope="scope">
		    		{{scope.row.menuLevel==1?'一级菜单':scope.row.menuLevel==2?'二级菜单':'三级按钮'}}
		    	</template>
		    </el-table-column>
		    <el-table-column prop="previousMenuName" label="上级菜单">
		    	<template slot-scope="scope">
		    		{{scope.row.previousMenuName?scope.row.previousMenuName:'顶级'}}
		    	</template>
		    </el-table-column>
		</el-table>
	  	<div style="margin-top: 20px">
	    	<div style="float:right">
			    <el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
			</div>
		</div>

		<!-- 添加菜单弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="120px">
      			<el-form-item label="菜单名称" prop="menuName">
				    <el-input v-model="ruleForm.menuName" style="width: 80%;"></el-input>
				</el-form-item>
				<el-form-item label="菜单类型" prop="menuLevel">
				    <el-radio-group v-model="ruleForm.menuLevel">
				      	<el-radio :label="1">一级菜单</el-radio>
				      	<el-radio :label="2">二级菜单</el-radio>
				      	<el-radio :label="3">三级按钮</el-radio>
				    </el-radio-group>
			  	</el-form-item>
		        <el-form-item label="一级菜单" v-if="ruleForm.menuLevel==2 || ruleForm.menuLevel==3" prop="previousMenuId" >
		          	<el-select v-model="ruleForm.previousMenuId" placeholder="请选择一级菜单" style="width: 80%;" @change="childMenuList">
		            	<el-option v-for="item in menulistData" :key="item.id" :label="item.menuName" :value="item.id">{{item.menuName}}</el-option>
		          </el-select>
		        </el-form-item>
				
				<input type="hidden" v-model="ruleForm.childMenuId">
				<el-form-item label="二级菜单" v-if="ruleForm.menuLevel==3" prop="childMenuId">
		          	<el-select v-model="ruleForm.childMenuName" placeholder="请选择二级菜单" style="width: 80%;" @change="childMenu">
		            	<el-option v-for="item in childMenuListData" :key="item.id" :label="item.menuName" :value="item.id">{{item.menuName}}</el-option>
		          </el-select>
		        </el-form-item>

		        <el-form-item label="菜单URL" v-if="ruleForm.menuLevel==2 || ruleForm.menuLevel==3" prop="menuAddress">
				    <el-input v-model="ruleForm.menuAddress" style="width: 80%;"></el-input>
				</el-form-item>

		        <el-form-item label="排序" prop="menuSort">
		        	<el-input-number v-model="ruleForm.menuSort" controls-position="right" :min="1" :max="10"></el-input-number>
				</el-form-item>
		        
      		</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
		    </span>
    	</el-dialog>
	</div>
</template>
<script>
export default {
    mounted() {
        this.init();
    },
    data() {
        return {
            pageNum: 1,
            limit: 10,
            totalPage: 10,
            headers: {
                xqiao_token: localStorage.getItem('token')
            },
            tableData3: [],
            dialogVisible: false,
            ruleForm: {
                menuSort: 1,
                childMenuName: '',
                childMenuId: ''
            },
            currentRow: '',
            menulistData: [],
            childMenuListData: [], //二级菜单
            rules: {
                menuName: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
                menuLevel: [{ required: true, message: '请选择菜单类型', trigger: 'change' }],
                previousMenuId: [{ required: true, message: '请选择一级菜单', trigger: 'change' }],
                childMenuId: [{ required: true, message: '请选择二级菜单', trigger: 'change' }],
                menuAddress: [{ required: true, message: '请输入菜单URL', trigger: 'blur' }],
                menuSort: [{ required: true, message: '请输入排序', trigger: 'blur' }]
            }
        };
    },
    methods: {
        init() {
            //视频列表
            var params = {
                pageNum: this.pageNum,
                limit: this.limit
            };
            this.$get('/authorityManagement/getManageMenu', params)
                .then(res => {
                    console.log(res);
                    if (res.code == 0) {
                        this.tableData3 = res.data.list;
                        this.totalPage = res.data.total;
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                        return false;
                    }
                })
                .catch(() => {
                    console.log();
                });
        },
        //当前页数
        handleCurrentChangePage(val) {
            this.pageNum = val;
            this.init();
        },
        add(row) {
            this.$refs.multipleTable.setCurrentRow(row);
            if (this.$refs['ruleForm']) {
                this.ruleForm = {
                    menuSort: 1
                };
                this.$refs['ruleForm'].resetFields();
            }
            this.pageNum = 1;
            this.currentRow = '';
            this.dialogVisible = true;
            this.menulist();
        },
        edit() {
            if (this.currentRow.id) {
                if (this.currentRow.previousMenuId == 0) {
                    this.currentRow.previousMenuId = '';
                }
                this.pageNum = 1;
                this.ruleForm = this.currentRow;
                this.menulist();
                this.dialogVisible = true;
            } else {
                this.dialogVisible = false;
                this.$message({
                    message: '请选择信息',
                    type: 'warning'
                });
                return false;
            }
        },
        del() {
            var that = this;
            if (that.currentRow.id) {
                that
                    .$confirm('确定要删除吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    .then(() => {
                        that
                            .$post(
                                '/authorityManagement/delManageMenu',
                                JSON.stringify(that.currentRow)
                            )
                            .then(function(res) {
                                console.log(res);
                                if (res.code == 0) {
                                    console.log(' 删除成功 ');
                                    that.$message({
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    that.currentRow = '';
                                    that.pageNum = 1;
                                    that.init();
                                    that.dialogVisible = false;
                                } else {
                                    that.errorMsg('操作失败');
                                }
                            })
                            .catch(function(err) {
                                console.log(err);
                            });
                    })
                    .catch(() => {});
            } else {
                that.$message({
                    message: '请选择信息',
                    type: 'warning'
                });
                return false;
            }
        },
        handleClose(done) {
            if (this.$refs.ruleForm != undefined) {
                this.$refs.ruleForm.resetFields();
                this.ruleForm = {
                    menuSort: 1
                };
            }
            done();
        },
        //选择需要修改的权限
        handleCurrentChange(val) {
            console.log(val);
            if (val) {
                this.currentRow = val;
            }
        },
        menulist() {
            var params = {
                pageNum: this.pageNum,
                limit: 20,
                menuLevel: 1
            };
            this.$get('/authorityManagement/getManageMenu', params).then(res => {
                console.log(res);
                if (res.code == 0) {
                    this.menulistData = res.data.list;
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                    return false;
                }
            });
        },
        onSubmit(formName) {
            if (this.ruleForm.menuLevel == 1) {
                this.ruleForm.previousMenuId = 0;
                this.ruleForm.menuAddress = '';
            } else if (this.ruleForm.menuLevel == 2) {
                this.ruleForm.parentMenuId = this.ruleForm.previousMenuId;
            } else if (this.ruleForm.menuLevel == 3) {
                this.ruleForm.previousMenuId = this.ruleForm.childMenuId;
            }
            console.log(this.ruleForm);
            // return false;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$post('/authorityManagement/addManageMenu', JSON.stringify(this.ruleForm))
                        .then(res => {
                            this.loading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: this.ruleForm.id ? '编辑成功' : '添加成功',
                                    type: 'success'
                                });
                                this.$refs.ruleForm.resetFields();
                                this.currentRow = '';
                                this.pageNum = 1;
                                this.init();
                                this.dialogVisible = false;
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'warning'
                                });
                                return false;
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        childMenuList(val) {
            this.ruleForm.childMenuId = val;
            if (val) {
                this.childMenuListDa('change');
            }
        },
        childMenuListDa(e) {
            var params = {
                menuLevel: 2,
                parentMenuId: this.ruleForm.childMenuId
            };
            this.$get('/authorityManagement/getManageMenu', params).then(res => {
                console.log(res);
                if (res.code == 0) {
                    this.childMenuListData = res.data.list;
                    if (e == 'change') {
                        this.ruleForm.childMenuName = res.data.list[0].menuName;
                        this.ruleForm.childMenuId = res.data.list[0].id;
                    }
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                    return false;
                }
            });
        },
        childMenu(val) {
            this.ruleForm.childMenuId = val;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/authorityManagement/menuList.vue